// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"736":"11ca6d71","867":"b8c53be3","2717":"c2ed55a1","4555":"7e2bda07","5770":"a8e04ecd","6264":"33f50ac7","6374":"6dcc69f3","8515":"4e0f7e65"}[chunkId] + ".chunk.css";
};